import React from 'react'
import { MdTrendingUp, MdShare, MdPeople, MdSecurity, MdDashboard, MdRocket } from 'react-icons/md'
import styles from './WhyUs.module.scss'

const reasons = [
  {
    id: 'allinone',
    title: 'Всё в одной системе',
    description: 'Сайт, приложение, склад, касса, персонал — единая платформа',
    icon: MdDashboard,
  },
  {
    id: 'profit',
    title: 'Выше маржинальность',
    description: 'Без комиссий агрегаторов, свои клиенты, своя база',
    icon: MdTrendingUp,
  },
  {
    id: 'fast',
    title: 'Запуск за 2–7 дней',
    description: 'Готовая витрина, приложение и приём заказов сразу',
    icon: MdRocket,
  },
  {
    id: 'reliable',
    title: process.env.REACT_APP_COUNTRY === 'ru' ? 'Российская платформа' : 'Международная платформа',
    description: 'Стабильная работа, полный цикл продаж, техподдержка',
    icon: MdSecurity,
  },
]

export const WhyUs: React.FC = () => {
  return (
    <div className={styles.grid}>
      {reasons.map(({ id, title, description, icon: Icon }) => (
        <div key={id} className={styles.card}>
          <Icon size={24} />
          <h4 className={styles.title}>{title}</h4>
          <p className={styles.description}>{description}</p>
        </div>
      ))}
    </div>
  )
}
